export const DEFAULT_URL_PARAMS = {
  lang: "no",
  view: "F",
  page: "1",
  data: "CHAMPS_pilot",
  itemIds: "true",
  itemTitles: "false",
} as const;

export type DefaultUrlParams = Partial<Record<
  "lang" | "view" | "page" | "data" | "itemIds" | "itemTitles" | "detailsWidth" | "detailsPosition",
  string
>>;

const ALLOWED = new Set(["lang", "view", "page", "data", "itemIds", "itemTitles", "detailsWidth", "detailsPosition"]);

export function normalizeDefaultUrlParams(input: unknown): DefaultUrlParams {
  if (!input || typeof input !== "object" || Array.isArray(input)) return { ...DEFAULT_URL_PARAMS };
  const result: DefaultUrlParams = {};
  for (const [key, value] of Object.entries(input)) {
    if (ALLOWED.has(key) && typeof value === "string") Object.assign(result, { [key]: value });
  }
  return result;
}

/** Resolve an initial view only after the configured view list is loaded. */
export function resolveStartupViewId(
  requested: string | null,
  views: readonly { id: string; visible: boolean }[],
): string {
  const preferred = views.find((view) => view.id === requested && view.visible);
  return preferred?.id ?? views.find((view) => view.visible)?.id ?? "";
}

/** Only missing query parameters are filled; user-supplied values always win. */
export function applyDefaultUrlParams(search: string, defaults: DefaultUrlParams): string {
  const params = new URLSearchParams(search);
  for (const [key, value] of Object.entries(defaults)) {
    if (!params.has(key)) params.set(key, value);
  }
  return "?" + params.toString();
}
